const NEO = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.41042 3.825V16.4917L9.64375 19.5V6.675L18.5896 3.35L10.4354 0.5L1.41042 3.825Z"
      fill="#00E599"
    />
    <path
      d="M10.277 7.15V13.9583L18.5895 16.9667V4.0625L10.277 7.15Z"
      fill="#00AF92"
    />
  </svg>
);
export default NEO;
